/** @jsxImportSource @emotion/react */
import { memo } from "react";

// CSS読み込み
import { validationErrorText } from "assets/css/stylesCss";

/**
 * Validation用エラーメッセージ
 * @param {String} children 子要素
 */
const ValidationErrorText = memo(({ children }) => {
  if(children !== "") {
    return <p css={validationErrorText}>{children}</p>;
  }
});

export default ValidationErrorText;
